<template>
  <div>
    <el-dialog :title="title"
               :visible.sync="dialogdata"
               width="400px"
               :close-on-click-modal="false"
               @open="opendialog">
      <div v-if="isEdit==2"
           class="myform">
        <el-form :model="dataInfo"
                 label-width="140px"
                 class="demo-ruleForm">
          <el-form-item label="医生姓名"
                        style="margin:-5px 0">
            {{dataInfo.doctor_name}}
          </el-form-item>
          <el-form-item label="身份证号"
                        style="margin:-5px 0">
            {{dataInfo.id_card}}
          </el-form-item>
          <el-form-item label="执业类别"
                        style="margin:-5px 0">
            {{dataInfo.practice_category}}
          </el-form-item>
          <el-form-item label="执业证书编码"
                        style="margin:-5px 0 30px">
            <div>
              {{dataInfo.practice_certificate_num}}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <div class="myform">
          <el-form :model="dataInfo"
                   :rules="rules"
                   ref="dataInfo"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-form-item label="医生姓名"
                          prop="doctor_name">
              <el-input v-model="dataInfo.doctor_name"
                        style="width: 240px"
                        maxlength="8"></el-input>
            </el-form-item>
            <el-form-item label="身份证号"
                          prop="id_card">
              <el-input v-model="dataInfo.id_card"
                        style="width: 240px"
                        maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="执业类别"
                          prop="practice_category">
              <el-select v-model="dataInfo.practice_category"
                         placeholder="请选择"
                         style="width: 240px">
                <el-option v-for="item in ['中医','临床','口腔','公共卫生']"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="执业证书编码"
                          prop="practice_certificate_num">
              <el-input v-model="dataInfo.practice_certificate_num"
                        style="width: 240px"
                        maxlength="50"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center; padding-bottom: 20px">
          <span slot="footer"
                class="dialog-footer">
            <el-button plain
                       @click="dialogdata = false">取消</el-button>
            <el-button type="primary"
                       @click="submitInfo('dataInfo')">保存</el-button>
          </span>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['isFlag', 'doctorInfo', 'isEdit', 'doctorId'],
  data() {
    return {
      dialogdata: false,
      title: '上传资料',
      rules: {
        doctor_name: [
          { required: true, message: '请输入医生姓名', trigger: 'blur' }
        ],
        id_card: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: '请输入数字或字母',
            trigger: ['blur', 'change']
          }
        ],
        practice_category: [
          { required: true, message: '请选择职业类别', trigger: 'blur' }
        ],
        practice_certificate_num: [
          { required: true, message: '请输入执业证书编码', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: '请输入数字或字母',
            trigger: ['blur', 'change']
          }
        ]
      },
      dataInfo: {}
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    close() {
      this.dialogdata = false;
    },
    //提交
    submitInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.dataInfo;
          if (this.isEdit) {
            this.$confirm(
              '当前医生正在购买保单中或保单已购买完成，确定要修改资料吗？',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
              }
            )
              .then(() => {
                this.axios
                  .post('platform/Doctor/updateSafeInfo', data)
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message.success('资料修改成功');
                      this.dialogdata = false;
                      this.$emit('refreshList');
                    }
                  });
              })
              .catch(() => {});
          } else {
            this.axios.post('platform/Doctor/addSafeInfo', data).then((res) => {
              if (res.code == 0) {
                this.$message.success('资料上传成功');
                this.dialogdata = false;
                this.$emit('refreshList');
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getDetail() {
      let doctor_id = this.doctorId;
      this.axios
        .post('platform/Doctor/doctorSafeDetail', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.dataInfo = {
              doctor_id: info.doctor_id,
              doctor_name: info.doctor_name,
              id_card: info.id_card,
              practice_category: info.practice_category,
              practice_certificate_num: info.practice_certificate_num
            };
          }
        });
    },
    opendialog() {
      if (this.isEdit == 0) {
        this.title = '上传资料';
        this.dataInfo = this.doctorInfo
      }
      if (this.isEdit == 1) {
        this.title = '编辑资料';
        this.dataInfo = {};
        this.getDetail();
      }
      if (this.isEdit == 2) {
        this.title = '查看资料';
        this.dataInfo = {};
        this.getDetail();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  border: solid 1px #cfcece;
  padding: 14px;
  box-sizing: border-box;
  margin: 20px 0;
}
.gray {
  color: #747981;
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.item {
  flex: 1;
  margin-bottom: 10px;
}
.myform {
  text-align: left;
  padding: 20px 10px 20px 0;
}
</style>